import { call, put, takeLatest } from 'redux-saga/effects';
import { Map, List } from 'immutable';
import { Notification } from '@utils';
import { getRequisicoes as getRequisicoesSdk } from '@sdk/Conectores/Requisicoes';

//Action Types
export const Types = {
  GET_REQUISICOES: 'GET_REQUISICOES',
  GET_REQUISICOES_SUCCESS: 'GET_REQUISICOES_SUCCESS',
  GET_REQUISICOES_ERROR: 'GET_REQUISICOES_ERROR',

  RESET_REQUISICOES: 'RESET_REQUISICOES',
};

//Action Creators
export const getRequisicoes = (idConfiguracao, page = 1) => ({ type: Types.GET_REQUISICOES, idConfiguracao, page });
export const getRequisicoesSuccess = (data) => ({ type: Types.GET_REQUISICOES_SUCCESS, data });
export const getRequisicoesError = (error) => ({ type: Types.GET_REQUISICOES_ERROR, error });

export const reset = () => ({ type: Types.RESET_REQUISICOES });

//saga

function* fetchGetRequisicoes(action) {
  try {
    const { page, idConfiguracao } = action;
    const requisicoes = yield call(getRequisicoesSdk, idConfiguracao, page);
    yield put(getRequisicoesSuccess(requisicoes));
  } catch (err) {
    Notification.error(err.message);
    yield put(getRequisicoesError(err));
  }
}

export const saga = [takeLatest(Types.GET_REQUISICOES, fetchGetRequisicoes)];

// Reducer
const initialState = Map({
  requisicoes: List(),
  xTotalPage: 0,
  xCurrentPage: 0,

  loadingRequisicoes: false,
  successRequisicoes: false,
  errorRequisicoes: false,
  hasMoreRequisicoes: false,
});

const handleGetRequisicoes = (state, action) => {
  return state.set('loadingRequisicoes', true).set('successRequisicoes', false).set('errorRequisicoes', false);
};

const handleGetRequisicoesSuccess = (state, action) => {
  const { requisicoes, xTotalPage, xCurrentPage } = action.data;
  let todasRequisicoes = List([...state.get('requisicoes').toArray(), ...requisicoes]);
  return state
    .set('requisicoes', todasRequisicoes)
    .set('xTotalPage', xTotalPage)
    .set('xCurrentPage', xCurrentPage)
    .set('hasMoreRequisicoes', xTotalPage !== xCurrentPage)
    .set('loadingRequisicoes', false)
    .set('successRequisicoes', true)
    .set('errorRequisicoes', false);
};

const handleGetRequisicoesError = (state, action) => {
  return state.set('loadingRequisicoes', false).set('successRequisicoes', false).set('errorRequisicoes', action.error);
};

const handleReset = (state, action) => {
  state = initialState;
  return state;
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_REQUISICOES:
      return handleGetRequisicoes(state, action);
    case Types.GET_REQUISICOES_SUCCESS:
      return handleGetRequisicoesSuccess(state, action);
    case Types.GET_REQUISICOES_ERROR:
      return handleGetRequisicoesError(state, action);

    case Types.RESET_REQUISICOES:
      return handleReset(state, action);

    default:
      return state;
  }
}
